import { Breadcrumb } from "antd";
import React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { checkPermissionAction } from "../../../Reusable/Store/Action/AuthPermissionsAction";
import commonCssStyle from "../../UI/CommonCss.module.css";
import PermissionMessage from "../../UI/PermissionMessage";
function BreadcrumbForRecruitment(props) {
  const navigate = useNavigate();
  const [openPMModal, setOpenPMModal] = useState({
    open: false,
    permission: "",
  });
  const array = [
    "Home",
    "Recruitment",
    `Job Details (${props.name})`,
    "Candidate Details",
  ];

  //getCheckPermissionHandler to check permision exist or not.
  //setOpenPMModal to set status for permission modal.
  return (
    <>
      <Breadcrumb>
        {props.slide &&
          props.slide.map((data, index) => {
            return (
              <Breadcrumb.Item key={index}>
                <p
                  className={` ${commonCssStyle.breadcrumbText} ${commonCssStyle.coursorPointer} ${commonCssStyle.marginBottomRemove}`}
                  onClick={() => {
                    if (data === 1) {
                      props.getCheckPermissionHandler(
                        "dashboard",
                        (success) => {
                          if (success) {
                            navigate("/dashboard");
                          } else {
                            setOpenPMModal({
                              open: true,
                              permission: "Dashboard",
                            });
                          }
                        }
                      );
                    } else if (data === 2) {
                      props.permissions &&
                      props.permissions.find(
                        (data) =>
                          data === "recruitment-list" ||
                          data === "recruitment-delete" ||
                          // data === "recruitment-add" ||
                          data === "recruitment-detail" ||
                          data === "recruitment-candidate-pool" ||
                          data === "recruitment-add-candidate" ||
                          data === "recruitment-candidate-detail" ||
                          data === "recruitment-candidate-status update" ||
                          data === "recruitment-candidate-mail-list" ||
                          data === "recruitment-candidate-mail-add" ||
                          data === "recruitment-candidate-timeline" ||
                          data === "recruitment-candidate-task-list" ||
                          data === "recruitment-candidate-download-resume" ||
                          data === "recruitment-candidate-download-recording" ||
                          data === "recruitment-candidate-call" ||
                          data === "recruitment-candidate-interview-list" ||
                          data === "recruitment-candidate-offerLetter" ||
                          data === "recruitment-delete-candidate"
                      )
                        ? navigate("/recruitment")
                        : setOpenPMModal({
                            open: true,
                            permission: "Recruitment",
                          });
                    } else if (data === 3) {
                      props.getCheckPermissionHandler(
                        "recruitment-detail",
                        (success) => {
                          if (success) {
                            navigate("/recruitment/recruitmentJobdetails", {
                              state: {
                                recuritmentJobDetailsName: props.name,
                                id: props.recruitmentId.id,
                                activeTabKey: "candidatePool",
                              },
                            });
                          } else {
                            setOpenPMModal({
                              open: true,
                              permission: "Recruitment Job Details",
                            });
                          }
                        }
                      );
                    } else if (data === 4) {
                      props.getCheckPermissionHandler(
                        "recruitment-detail",
                        (success) => {
                          if (success) {
                            navigate("/recruitment/recruitmentJobdetails", {
                              state: {
                                recuritmentJobDetailsName: props.name,
                                id: props.recruitment.id,
                              },
                            });
                          } else {
                            setOpenPMModal({
                              open: true,
                              permission: "Recruitment Job Details",
                            });
                          }
                        }
                      );
                    }
                    //   else if (data === 4) {
                    //     navigate("/candidatesDetailsPage/summary", {
                    //       state: {
                    //         recuritmentJobDetailsName: props.name,
                    //         // id: props.candidateId,
                    //       },
                    //     });
                    //   }
                  }}
                >
                  {array[index]}
                </p>
              </Breadcrumb.Item>
            );
          })}
      </Breadcrumb>
      <PermissionMessage
        onOpenPMModal={openPMModal}
        onClosePMModal={() => {
          setOpenPMModal({ open: false, permission: "" });
          props.setIsHavepermissionsHandler(false);
        }}
      />
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    permissions: state.authpermissions.permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getCheckPermissionHandler: (id, callback) => {
      dispatch(checkPermissionAction(id, callback));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BreadcrumbForRecruitment);
